import React, { Component } from "react";
import "./PlanSuggestionOffers.css";
import PlanSuggestionOfferItem from "./PlanSuggestionOfferItem";

class PlanSuggestionOffers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestedOffers: [],
      plans: {
        "plan-4x5G-98-20GB": {
          campaignCode: "NW3HKWM1",
          urlTc: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/simplan/index.html?cmpid=web_navigation_4.5gplan_240327_nil_tc_98`,
          urlEn: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/simplan/index-en.html?cmpid=web_navigation_4.5gplan_240327_nil_en_98`,
        },
        "plan-4x5G-120-FUP": {
          campaignCode: "NW3HKXM1",
          urlTc: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/simplan/index.html?cmpid=web_navigation_4.5gplan_240327_nil_tc_120`,
          urlEn: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/simplan/index-en.html?cmpid=web_navigation_4.5gplan_240327_nil_en_120`,
        },
        "plan-5G-124-30GB": {
          campaignCode: "NW3HKV6M1",
          urlTc: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/5g/index.html?cmpid=web_navigation_5gplan_240327_nil_tc_124`,
          urlEn: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/5g/index-en.html?cmpid=web_navigation_5gplan_240327_nil_en_124`,
        },
        "plan-5G-188-60GB": {
          campaignCode: "NW3HKV9M1",
          urlTc: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/5g/index.html?cmpid=web_navigation_5gplan_240327_nil_tc_188`,
          urlEn: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/5g/index-en.html?cmpid=web_navigation_5gplan_240327_nil_en_188`,
        },
        "plan-5G-148-50GB": {
          campaignCode: "NW3HKV0M1",
          urlTc: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/5g/index.html?cmpid=web_navigation_5gplan_240327_nil_tc_148`,
          urlEn: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/5g/index-en.html?cmpid=web_navigation_5gplan_240327_nil_en_148`,
        },
        "plan-4x5G-88-16GB": {
          campaignCode: "NW3HKYM1",
          urlTc: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/simplan/index.html?cmpid=web_navigation_4.5gplan_240625_nil_tc_88`,
          urlEn: `${
            process.env.REACT_APP_ONLINE_ACQ_DOMAIN
          }/plans/simplan/index-en.html?cmpid=web_navigation_4.5gplan_240625_nil_en_88`,
        },
      },
    };
  }

  componentDidMount() {
    this.getSuggestedOffers();
  }

  getSuggestedOffers() {
    const { answers } = this.props;
    const { plans } = this.state;

    const suggestedOffers = [];

    const questionDataUseMonthly = answers["question-data-use-monthly"];
    const questionTravelCNMO = answers["question-travel-cnmo"];
    const questionDataUseMonthlyCalculate =
      answers["question-data-use-monthly-calculate"];

    let tempPlan;

    if (questionDataUseMonthly != null) {
      if (questionDataUseMonthly == 0) {
        switch (questionTravelCNMO) {
          case 0:
            suggestedOffers.push(plans["plan-4x5G-98-20GB"]);
            break;
          case 1:
            suggestedOffers.push(plans["plan-4x5G-88-16GB"]);
            break;
          case 2:
            suggestedOffers.push(plans["plan-4x5G-88-16GB"]);
            break;
          case 3:
            suggestedOffers.push(plans["plan-4x5G-88-16GB"]);
            break;
        }
      }

      if (questionDataUseMonthly == 1) {
        switch (questionTravelCNMO) {
          case 0:
            suggestedOffers.push(plans["plan-4x5G-120-FUP"]);
            suggestedOffers.push(plans["plan-5G-124-30GB"]);
            break;
          case 1:
            suggestedOffers.push(plans["plan-5G-148-50GB"]);
            break;
          case 2:
            suggestedOffers.push(plans["plan-5G-148-50GB"]);
            break;
          case 3:
            tempPlan = plans["plan-5G-148-50GB"];
            tempPlan["funSharePack"] = true;
            suggestedOffers.push(tempPlan);
            break;
        }
      }

      if (questionDataUseMonthly == 2) {
        switch (questionTravelCNMO) {
          case 0:
            suggestedOffers.push(plans["plan-4x5G-120-FUP"]);
            suggestedOffers.push(plans["plan-5G-188-60GB"]);
            break;
          case 1:
            suggestedOffers.push(plans["plan-5G-188-60GB"]);
            break;
          case 2:
            tempPlan = plans["plan-5G-188-60GB"];
            tempPlan["funSharePack"] = true;
            suggestedOffers.push(tempPlan);
            break;
          case 3:
            tempPlan = plans["plan-5G-188-60GB"];
            tempPlan["funSharePack"] = true;
            suggestedOffers.push(tempPlan);
            break;
        }
      }

      if (questionDataUseMonthly == 3) {
        const estimatedDataUsage = questionDataUseMonthlyCalculate["dataUse"];
        const videoStreaming = questionDataUseMonthlyCalculate["streaming"];
        if (estimatedDataUsage <= 20) {
          switch (questionTravelCNMO) {
            case 0:
              suggestedOffers.push(plans["plan-4x5G-98-20GB"]);
              break;
            case 1:
              suggestedOffers.push(plans["plan-4x5G-88-16GB"]);
              break;
            case 2:
              suggestedOffers.push(plans["plan-4x5G-88-16GB"]);
              break;
            case 3:
              suggestedOffers.push(plans["plan-4x5G-88-16GB"]);
              break;
          }
        } else if (estimatedDataUsage > 20 && estimatedDataUsage <= 50) {
          switch (questionTravelCNMO) {
            case 0:
              suggestedOffers.push(plans["plan-4x5G-120-FUP"]);
              suggestedOffers.push(plans["plan-5G-124-30GB"]);
              break;
            case 1:
              suggestedOffers.push(plans["plan-5G-148-50GB"]);
              break;
            case 2:
              suggestedOffers.push(plans["plan-5G-148-50GB"]);
              break;
            case 3:
              tempPlan = plans["plan-5G-148-50GB"];
              tempPlan["funSharePack"] = true;
              suggestedOffers.push(tempPlan);
              break;
          }
        } else if (estimatedDataUsage > 30 && estimatedDataUsage <= 50) {
          switch (questionTravelCNMO) {
            case 0:
              suggestedOffers.push(plans["plan-4x5G-120-FUP"]);

              tempPlan = plans["plan-5G-148-50GB"];
              tempPlan["videoStreaming"] = videoStreaming >= 3;
              suggestedOffers.push(tempPlan);
              break;
            case 1:
              tempPlan = plans["plan-5G-188-60GB"];
              tempPlan["videoStreaming"] = videoStreaming >= 3;
              suggestedOffers.push(tempPlan);
              break;
            case 2:
              tempPlan = plans["plan-5G-148-50GB"];
              tempPlan["videoStreaming"] = videoStreaming >= 3;
              suggestedOffers.push(tempPlan);
              break;
            case 3:
              tempPlan = plans["plan-5G-148-50GB"];
              tempPlan["funSharePack"] = true;
              tempPlan["videoStreaming"] = videoStreaming >= 3;
              suggestedOffers.push(tempPlan);
              break;
          }
        } else{
          switch (questionTravelCNMO) {
            case 0:
              suggestedOffers.push(plans["plan-4x5G-120-FUP"]);              
              tempPlan = plans["plan-5G-188-60GB"];
              tempPlan["videoStreaming"] = videoStreaming >= 3;
              suggestedOffers.push(tempPlan);
              break;
            case 1:
              tempPlan = plans["plan-5G-188-60GB"];
              tempPlan["videoStreaming"] = videoStreaming >= 3;
              suggestedOffers.push(tempPlan);
              break;
            case 2:
              tempPlan = plans["plan-5G-188-60GB"];
              tempPlan["funSharePack"] = true;
              tempPlan["videoStreaming"] = videoStreaming >= 3;
              suggestedOffers.push(tempPlan);
              break;
            case 3:
              tempPlan = plans["plan-5G-188-60GB"];
              tempPlan["funSharePack"] = true;
              tempPlan["videoStreaming"] = videoStreaming >= 3;
              suggestedOffers.push(tempPlan);
              break;
          }
        }
      }

      this.setState({ suggestedOffers });
    }
  }

  render() {
    const { suggestedOffers } = this.state;

    console.log("suggestedOffers",suggestedOffers);

    const lang = window.THREE_REACT_APP_GLOBAL.language;
    let header, subHeader, tncRemark;
    if (lang === "tc") {
      header = "";
      subHeader = "已經為你選出最合適嘅月費計劃";
      tncRemark = "受條款及細則約束。";
    } else {
      header = "";
      subHeader = `Below monthly ${
        suggestedOffers.length > 1 ? "plans look" : "plan looks"
      } suitable for you`;
      tncRemark = "Terms and conditions apply.";
    }

    return (
      <div className="card-question-general">
        <div className="header">{header}</div>

        <div className="body">
          <div className="label-tnc-remark">{tncRemark}</div>

          <div className="sub-header">{subHeader}</div>

          <div class="container-plan-suggestion-offers">
            {suggestedOffers.map((offer) => (
              <PlanSuggestionOfferItem key={offer.campaignCode} offer={offer} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default PlanSuggestionOffers;
